import type { AxiosResponse } from 'axios';
import { api } from '@/services/api/main/axios';

export type ArchiveEntityUsedItem = {
  usedName: string;
  usingType: string;
  usingName: string;
};

export type ArchiveEntityPayload = {
  usedItems?: ArchiveEntityUsedItem[];
};

export const postEntityArchiveApiRequest = async (
  entityType: string,
  ids: string[],
): Promise<AxiosResponse<{ payload: ArchiveEntityPayload }>> => {
  return api.post<{ payload: ArchiveEntityPayload }>(`${entityType}/archive`, { ids });
};

export const postEntityRestoreApiRequest = async (
  entityType: string,
  ids: string[],
): Promise<void> => {
  await api.post(`${entityType}/restore`, { ids });
};

export type EntityNamePayload = {
  id?: string;
  name: string;
  nameFull?: string;
};

export const getEntityNameApiRequest = async (
  entityType: string,
  id: string,
): Promise<AxiosResponse<{ payload: EntityNamePayload }>> => {
  return api.get<{ payload: EntityNamePayload }>(`${entityType}/name/${id}`);
};

export const patchEntityChangeWorkspaceApiRequest = async (
  entityType: string,
  elementId: string,
  workspaceId: string,
): Promise<void> => {
  await api.patch(`${entityType}/${elementId}/change-workspace`, { workspaceId });
};

export const postEntityCreateApiRequest = async <T extends { id: string }>(
  endpoint: string,
  payload: object,
): Promise<T> => {
  const res = await api.post<{ payload: T }>(endpoint, payload);
  return res.data.payload;
};
